import { render, staticRenderFns } from "./tagStudent.vue?vue&type=template&id=1ecd48ac&scoped=true"
import script from "./tagStudent.vue?vue&type=script&lang=js"
export * from "./tagStudent.vue?vue&type=script&lang=js"
import style0 from "./tagStudent.vue?vue&type=style&index=0&id=1ecd48ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd48ac",
  null
  
)

export default component.exports